import { useIsPrepwQuizEnabled } from '../experiments/dais-3587_v1_persona_prepw_quiz'

export const paths = {
  root: '/',
  // account management routes
  settings: '/settings',
  // Auth & checkout routes
  personaCustomAuth: (
    method: 'login' | 'signup' | 'forgot-password' | string,
  ) => `/${method}`,
  // checkout routes
  personaCheckoutRoot: '/checkout',
  personaCheckoutSignUp: '/checkout/signup',
  personaCheckoutMembership: '/checkout/membership',
  personaCheckoutPayment: '/checkout/payment',
  personaCheckoutComplete: '/checkout/success',
  prePwQuiz: '/quiz',
  // help resources & legal routes
  // TODO: Move legal, faq, footer routes here
  helpCenter: '/help-center',
  requestDataDeletion:
    'https://privacy.masterclass.com/policies?modal=select-subject',
  // This will just redirect to whatever is the current homepage
  homepage: '/homepage',
  coaches: '/coaches',
  roleplay: '/categories',
  roleplayCategory: (category: string) => `/categories/${category}`,
  masterclassCoreSettings: 'https://www.masterclass.com/account/edit',
  // aimentor (persona) routes
  bio: (instructorSlug = ':instructorSlug') => `/aimentor/${instructorSlug}`,
  personaCall: (instructorSlug = ':instructorSlug') =>
    `/aimentor/${instructorSlug}/call`,
  personaChat: (instructorSlug = ':instructorSlug', topicUuid: string = '') =>
    `/aimentor/${instructorSlug}/chat${topicUuid ? `?topic_uuid=${topicUuid}` : ''}`,
  personaLibrary: (instructorSlug = ':instructorSlug') =>
    `/library/${instructorSlug}`,
  personaRoleplayStart: (
    categorySlug = ':categorySlug',
    scenarioSlug = ':scenarioSlug',
    userRoleplayUuid = ':userRoleplayUuid',
  ) =>
    `${baseRoleplaySetupPath(categorySlug, scenarioSlug)}/start${
      userRoleplayUuid ? `?uuid=${userRoleplayUuid}` : ''
    }`,
  personaRoleplaySetup: (
    categorySlug = ':categorySlug',
    scenarioSlug = ':scenarioSlug',
  ) => `${baseRoleplaySetupPath(categorySlug, scenarioSlug)}`,
  personaRoleplayCustomSetup: '/categories/scenario/custom',
  personaRoleplaySession: (
    categorySlug = ':categorySlug',
    scenarioSlug = ':scenarioSlug',
    userRoleplayUuid = ':userRoleplayUuid',
  ) =>
    `${baseRoleplaySetupPath(categorySlug, scenarioSlug)}/session${
      userRoleplayUuid ? `?uuid=${userRoleplayUuid}` : ''
    }`,
  personaRoleplayFeedback: (
    categorySlug = ':categorySlug',
    scenarioSlug = ':scenarioSlug',
    conversationUuid = ':conversationUuid',
  ) =>
    `${baseRoleplaySetupPath(categorySlug, scenarioSlug)}/feedback?uuid=${conversationUuid}`,
  onboarding: '/onboarding',
  forYou: '/for-you',
}

export const isCoachesPath = (pathname: string) =>
  pathname.includes(paths.coaches)

export const isCategoriesPath = (pathname: string) =>
  pathname.includes(paths.roleplay)

const baseRoleplaySetupPath = (
  categorySlug = ':categorySlug',
  scenarioSlug = ':scenarioSlug',
) => `/categories/${categorySlug}/scenario/${scenarioSlug}`

export const useCheckoutPath = () => {
  const isPrepwQuizEnabled = useIsPrepwQuizEnabled()

  return isPrepwQuizEnabled ? paths.prePwQuiz : paths.personaCheckoutSignUp
}
